/**
 * Partición de la cola de la carga masiva cuando el usuario elige
 * "Omitir existentes" en el diálogo de duplicados.
 *
 * Recibe los items en cola y el mapa de duplicados (item.id → docRef del
 * archivo existente) y devuelve dos listas: `pending` (se suben) y `skipped`
 * (copias con status 'skipped'; los existentes quedan intactos en el destino).
 * No muta los items de entrada y conserva el orden original.
 */
export const partitionSkipped = (items, replaceMap) => {
  const pending = [];
  const skipped = [];
  for (const it of items) {
    if (replaceMap && replaceMap.has(it.id)) skipped.push({ ...it, status: 'skipped' });
    else pending.push(it);
  }
  return { pending, skipped };
};
